var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipelineDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 9H15.1875M2.8125 11.8125H15.1875M2.8125 14.625H15.1875M4.21875 3.375H13.7812C14.1542 3.375 14.5119 3.52316 14.7756 3.78688C15.0393 4.0506 15.1875 4.40829 15.1875 4.78125C15.1875 5.15421 15.0393 5.5119 14.7756 5.77562C14.5119 6.03934 14.1542 6.1875 13.7812 6.1875H4.21875C3.84579 6.1875 3.4881 6.03934 3.22438 5.77562C2.96066 5.5119 2.8125 5.15421 2.8125 4.78125C2.8125 4.40829 2.96066 4.0506 3.22438 3.78688C3.4881 3.52316 3.84579 3.375 4.21875 3.375V3.375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineDark);
export default __webpack_public_path__ + "static/media/pipelineDark.e2c566bbd4a1f24cdcd5ef6d4a8e0615.svg";
export { ForwardRef as ReactComponent };